import React from "react";
import styled from "styled-components";
import { ButtonProps, StyledButtonProps } from "./types";

const StyledButton = styled.button<StyledButtonProps>(
  ({ primary, disabled, hide, isFirstStep, isLastStep, small }) => `
  width: 100%;
  border-radius: 5px;
  border: 2px solid var(--green);
  padding: .8rem 1.5rem;
  font-size: var(--font-size-18);
  line-height: var(--line-spacing-22-5);
  letter-spacing: var(--character-spacing-0);
  color: ${primary ? "var(--white)" : "var(--black)"}; 
  background-color: ${primary ? "var(--green)" : "var(--white)"};
  cursor: pointer;
  opacity:${disabled ? "0.5" : "1"};
  display:${hide ? "none" : "block"};
  margin-top: 1rem;

  @media (min-width: 700px) {
    width:${small ? "30%" : "280px"};
  }

  transition: background-color 0.3s ease;
`
);

export default function Button({
  id,
  children,
  onClick,
  type = "button",
  disabled,
  primary,
  small,
  hide = false,
  isFirstStep,
  isLastStep,
  buttonStyles,
  cookieType,
}: ButtonProps) {
  return (
    <>
      <StyledButton
        id={id}
        onClick={onClick}
        type={type}
        disabled={disabled}
        primary={primary}
        hide={hide}
        isFirstStep={isFirstStep}
        isLastStep={isLastStep}
        small={small}
        style={buttonStyles}
      >
        {children}
      </StyledButton>
    </>
  );
}
